// extracted by mini-css-extract-plugin
module.exports = {"read-more":"ReadMore_read-more__6j_SW"};